<template>
  <div class="background-fade px-4">
    <transition name="slide-down">
      <div v-if="activeFilter" class="filter-banner">
        <div class="filter-banner-top">
          <span>
            <strong>Vista filtrada</strong> &nbsp;·&nbsp;
            {{ activeFilter.dependency }}
            <span
              v-if="
                activeFilter.subgrupo &&
                  activeFilter.subgrupo !== activeFilter.dependency
              "
            >
              &nbsp;·&nbsp; {{ activeFilter.subgrupo }}
            </span>
            &nbsp;·&nbsp; <strong>n = {{ activeFilter.n }}</strong>
          </span>
          <button class="filter-banner-clear" @click="clearFilter">
            ✕ Limpiar filtro
          </button>
        </div>
        <div v-if="activeFilter.items" class="filter-banner-items">
          <span
            v-for="(item, i) in activeFilter.items"
            :key="i"
            class="filter-banner-chip"
            >{{ item.label }}</span
          >
        </div>
      </div>
    </transition>
    <div class="box custom-metric-box p-6">
      <div class="resumen-cultura columns is-vcentered is-mobile">
        <!-- Columna izquierda -->
        <div class="column is-half">
          <div class="is-flex is-justify-content-space-between is-align-items-start">
            <div>
              <h2 class="title is-4">Resumen del Resultado de Cultura</h2>

              <p class="is-size-6">
                Fecha del diagnóstico:
                <span class="has-text-primary has-text-weight-medium">
                  {{ dateProcess }}
                </span>
              </p>
            </div>
            
          </div>
        </div>

        <!-- Columna derecha (tarjetas) -->
        <div class="column is-half">
          <div class="columns is-mobile">
            <div class="column">
              <div class="has-text-centered">
                <p class="has-text-grey is-size-7 has-text-weight-semibold">
                  Participación
                </p>
                <p class="is-size-5 has-text-weight-bold">
                  {{ participacion }}
                </p>
              </div>
            </div>
            <div class="column">
              <div class="has-text-centered">
                <p class="has-text-grey is-size-7 has-text-weight-semibold">
                  Cultura actual
                </p>
                <p class="is-size-5 has-text-weight-bold">
                  {{ encuestados
                  }}<span class="is-size-7 ml-1"
                    >({{ participacionActual }})</span
                  >
                </p>
              </div>
            </div>
            <div class="column">
              <div class="has-text-centered">
                <p class="has-text-grey is-size-7 has-text-weight-semibold">
                  Cultura deseada
                </p>
                <p class="is-size-5 has-text-weight-bold">
                  {{ deseada }}
                  <span class="is-size-7 ml-1"
                    >({{ participacionDeseada }})</span
                  >
                </p>
              </div>
            </div>
            <div
              class="column is-narrow is-flex is-align-items-center"
              style="gap: 0.5rem;"
              v-if="!isShared"
            >
              <b-button
                v-tooltip.left="{
                  content: 'Copiar link de tablero',
                  classes: 'cultura-tooltip',
                }"
                icon-left="share"
                size="is-small"
                @click="copyLink()"
              >
                Compartir
              </b-button>
              <b-button
                v-tooltip.left="{
                  content: 'Descargar datos generales',
                  classes: 'cultura-tooltip',
                }"
                icon-left="download"
                size="is-small"
                @click="downloadResultsData()"
              >
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-two-fifths">
          <ResultsChart
            :actual="culturaActual"
            :deseada="culturaDeseada"
            :size="'lg'"
            :maxValue="maxGlobalValue"
            :steps="10"
          />
        </div>
        <div class="column mt-5">
          <ResultsTable :rows="culturaTabla" />
        </div>
      </div>
    </div>
    <div class="box custom-metric-box p-6">
      <h3 class="title is-5">Detalle cultura actual por subgrupo</h3>
      <ResultsTableGroups
        ref="tableGroups"
        :rowData="dataGroups"
        @selection-changed="loadGroupFilter"
      />
    </div>
    <div class="box custom-metric-box p-6">
      <GroupComparison
        :dataGroups="dataGroups"
        :totalActual="culturaActual"
        :totalDeseada="culturaDeseada"
        :totalN="totalCalculatedN"
      />
    </div>
    <div class="box custom-metric-box p-6">
      <div
        class="is-flex is-justify-content-space-between is-align-items-center mb-4"
      >
        <h3 class="title is-5">Detalle por dimensiones</h3>
        <!-- Toggle -->
        <!-- <b-button
          type="is-primary"
          size="is-small"
          @click="showRadar = !showRadar"
        >
          {{ showRadar ? 'Ver gráficos de barras' : 'Ver gráficos radar' }}
        </b-button> -->
        <div class="chart-toggle">
          <div class="toggle-wrapper">
            <span
              class="toggle-item"
              :class="{ active: showRadar }"
              @click="showRadar = true"
            >
              Cuadrantes
            </span>
            <span class="divider">|</span>

            <span
              class="toggle-item"
              :class="{ active: !showRadar }"
              @click="showRadar = false"
            >
              Barras
            </span>
          </div>
        </div>
      </div>
      <div v-if="showRadar">
        <div class="columns">
          <div class="column is-one-third">
            <h4 class="title is-6">Características dominantes</h4>
            <ResultsChart
              :actual="culturaActual_1"
              :deseada="culturaDeseada_1"
              :size="'sm'"
              :maxValue="maxDimsValue"
            />
          </div>
          <div class="column is-one-third">
            <h4 class="title is-6">Criterios de éxito</h4>
            <ResultsChart
              :actual="culturaActual_2"
              :deseada="culturaDeseada_2"
              :size="'sm'"
              :maxValue="maxDimsValue"
            />
          </div>
          <div class="column is-one-third">
            <h4 class="title is-6">Liderazgo organizacional</h4>
            <ResultsChart
              :actual="culturaActual_3"
              :deseada="culturaDeseada_3"
              :size="'sm'"
              :maxValue="maxDimsValue"
            />
          </div>
        </div>
        <div class="columns mt-5">
          <div class="column is-one-third">
            <h4 class="title is-6">Énfasis estratégico</h4>
            <ResultsChart
              :actual="culturaActual_4"
              :deseada="culturaDeseada_4"
              :size="'sm'"
              :maxValue="maxDimsValue"
            />
          </div>
          <div class="column is-one-third">
            <h4 class="title is-6">Solución de problemas</h4>
            <ResultsChart
              :actual="culturaActual_5"
              :deseada="culturaDeseada_5"
              :size="'sm'"
              :maxValue="maxDimsValue"
            />
          </div>
          <div class="column is-one-third">
            <h4 class="title is-6">Valores</h4>
            <ResultsChart
              :actual="culturaActual_6"
              :deseada="culturaDeseada_6"
              :size="'sm'"
              :maxValue="maxDimsValue"
            />
          </div>
        </div>
      </div>
      <div v-else>
        <div class="chart-legend mt-[-20px] mb-5">
          <div class="legend-row">
            <div class="legend-item">
              <span
                class="legend-swatch swatch-actual"
                aria-hidden="true"
              ></span>
              <span class="legend-text">Actual</span>
            </div>

            <div class="legend-separator" aria-hidden="true"></div>

            <div class="legend-item">
              <span
                class="legend-swatch swatch-deseada"
                aria-hidden="true"
              ></span>
              <span class="legend-text">Deseada</span>
            </div>

            <!-- si quieres agregar otro elemento (ejemplo: Brecha) descomenta:
            <div class="legend-separator"></div>
            <div class="legend-item">
              <span class="legend-swatch swatch-brecha" aria-hidden="true"></span>
              <span class="legend-text">Brecha</span>
            </div>
            -->
          </div>
        </div>
        <ResultsBars
          :items="[
            {
              title: 'Características dominantes',
              actual: culturaActual_1,
              deseada: culturaDeseada_1,
            },
            {
              title: 'Criterios de éxito',
              actual: culturaActual_2,
              deseada: culturaDeseada_2,
            },
            {
              title: 'Liderazgo organizacional',
              actual: culturaActual_3,
              deseada: culturaDeseada_3,
            },
            {
              title: 'Énfasis estratégico',
              actual: culturaActual_4,
              deseada: culturaDeseada_4,
            },
            {
              title: 'Solución de problemas',
              actual: culturaActual_5,
              deseada: culturaDeseada_5,
            },
            {
              title: 'Valores',
              actual: culturaActual_6,
              deseada: culturaDeseada_6,
            },
          ]"
          :maxValue="maxDimsValue"
          :steps="20"
        />
      </div>
    </div>
    <div class="box custom-metric-box p-6">
      <div
        class="is-flex is-justify-content-space-between is-align-items-center mb-4"
      >
        <h3 class="title is-4">Palabras claves {{ currentProcess.name }}</h3>
        <div class="chart-toggle">
          <div class="toggle-wrapper">
            <span
              class="toggle-item"
              :class="{ active: wordsView === 'cloud' }"
              @click="wordsView = 'cloud'"
            >
              Nube
            </span>
            <span class="divider">|</span>
            <span
              class="toggle-item"
              :class="{ active: wordsView === 'table' }"
              @click="wordsView = 'table'"
            >
              Tabla
            </span>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-one-half">
          <h5 class="title is-6 header-actual ">La cultura es...</h5>
          <WordCloud
            v-if="wordsView === 'cloud'"
            :words="processedWordsActual"
            :width="600"
            :height="400"
            :maxWords="30"
            @word-click="onWordSelected"
          />
          <div v-else class="words-table-wrapper">
            <table class="table is-fullwidth is-hoverable words-table">
              <thead>
                <tr>
                  <th class="col-rank">#</th>
                  <th class="col-word">Palabra</th>
                  <th class="col-freq">Frecuencia</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(w, i) in processedWordsActual"
                  :key="'a-' + w.text"
                  @click="onWordSelected(w)"
                  style="cursor: pointer;"
                >
                  <td>{{ i + 1 }}</td>
                  <td>{{ w.text.replace(/_/g, " ") }}</td>
                  <td>
                    <div class="freq-bar">
                      <div
                        class="freq-bar-fill"
                        :style="{ width: (w.value / (processedWordsActual[0] && processedWordsActual[0].value || 1)) * 100 + '%' }"
                      ></div>
                      <span class="freq-bar-label">{{ w.value }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="column is-one-half">
          <h5 class="title is-6 header-deseada">La cultura debería ser...</h5>
          <WordCloud
            v-if="wordsView === 'cloud'"
            :words="processedWordsDeseada"
            :width="600"
            :height="400"
            :maxWords="30"
            @word-click="onWordSelected"
          />
          <div v-else class="words-table-wrapper">
            <table class="table is-fullwidth is-hoverable words-table">
              <thead>
                <tr>
                  <th class="col-rank">#</th>
                  <th class="col-word">Palabra</th>
                  <th class="col-freq">Frecuencia</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(w, i) in processedWordsDeseada"
                  :key="'d-' + w.text"
                  @click="onWordSelected(w)"
                  style="cursor: pointer;"
                >
                  <td>{{ i + 1 }}</td>
                  <td>{{ w.text.replace(/_/g, " ") }}</td>
                  <td>
                    <div class="freq-bar">
                      <div
                        class="freq-bar-fill"
                        :style="{ width: (w.value / (processedWordsDeseada[0] && processedWordsDeseada[0].value || 1)) * 100 + '%' }"
                      ></div>
                      <span class="freq-bar-label">{{ w.value }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div
        v-if="tokenUser && tokenUser.admin"
        class="is-flex is-justify-content-flex-end"
      >
        <b-button
          icon-left="download"
          size="is-small"
          @click="downloadWords"
        >
          Descargar frases
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import ResultsChart from "./ResultsChart.vue";
import ResultsTable from "./ResultsTable.vue";
import ResultsTableGroups from "./ResultsTableGroups.vue";
import ResultsBars from "./ResultsBars.vue";
import WordCloud from "./ResultsCloud.vue";
import GroupComparison from "./GroupComparison.vue";
import {
  getResultByProcess,
  getResultByDependency,
  getSharedResults,
} from "../../api";
import store from "../../store";
import { buildWordCloudData } from "../../helpers";
const XLSX = require("xlsx");

export default {
  name: "Results",

  components: {
    ResultsChart,
    ResultsTable,
    ResultsTableGroups,
    ResultsBars,
    WordCloud,
    GroupComparison,
  },
  data() {
    return {
      showRadar: true,
      wordsView: "cloud",
      culturaActual: [],
      culturaDeseada: [],
      culturaTabla: [],
      culturaActual_1: [],
      culturaDeseada_1: [],

      culturaActual_2: [],
      culturaDeseada_2: [],

      culturaActual_3: [],
      culturaDeseada_3: [],

      culturaActual_4: [],
      culturaDeseada_4: [],

      culturaActual_5: [],
      culturaDeseada_5: [],

      culturaActual_6: [],
      culturaDeseada_6: [],

      dateProcess: "",
      encuestados: 0,
      participacion: 0,
      totalCalculatedN: 0,
      dataGroups: [],
      processedWordsActual: [],
      processedWordsDeseada: [],
      frases: [],
      actual: 0,
      deseada: 0,
      actualCalculada: 0,
      deseadaCalculada: 0,
      participacionActual: 0,
      participacionDeseada: 0,
      rawRes: null,
      activeFilter: null,
      pendingFilterRows: null,
      lastFilterRows: [],
    };
  },
  computed: {
    currentProcess() {
      return store.state.selectedProcess;
    },
    tokenUser() {
      return this.$store.state.tokenUser;
    },
    isShared() {
      return !!this.$route.params.id;
    },
    maxGlobalValue() {
      const allValues = [...this.culturaActual, ...this.culturaDeseada].filter(
        (v) => typeof v === "number",
      );

      return Math.max(...allValues, 0);
    },
    maxDimsValue() {
      const allValues = [
        ...this.culturaActual_1,
        ...this.culturaDeseada_1,
        ...this.culturaActual_2,
        ...this.culturaDeseada_2,
        ...this.culturaActual_3,
        ...this.culturaDeseada_3,
        ...this.culturaActual_4,
        ...this.culturaDeseada_4,
        ...this.culturaActual_5,
        ...this.culturaDeseada_5,
        ...this.culturaActual_6,
        ...this.culturaDeseada_6,
      ].filter((v) => typeof v === "number");

      return Math.max(...allValues, 0);
    },
  },
  created() {
    this.getDataResults();
  },
  methods: {
    toggleCharts() {
      this.showRadar = !this.showRadar;
    },
    async getDataResults() {
      const processId = this.isShared
        ? this.$route.params.id
        : this.currentProcess._id;

      const fetchBase = this.isShared
        ? getSharedResults(processId, [])
        : getResultByProcess(processId);

      await fetchBase.then((res) => {
        this.rawRes = res;

        this.applyResultsData(res);

        this.dateProcess = new Date(
          this.currentProcess.createdAt,
        ).toLocaleDateString("es-ES", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        });
        this.encuestados = res.total;
        this.participacion =
          this.encuestados > 0
            ? Math.round((100 * 10 * res.totalCalculated) / this.encuestados) /
                10 +
              "%"
            : "-";
        this.actual = res.totalToday;
        this.deseada = res.totalFuture;
        this.actualCalculada = res.todayCalculated;
        this.deseadaCalculada = res.futureCalculted;
        this.participacionActual = this.actual
          ? Math.round(100 * 10 * (this.actualCalculada / this.actual)) / 10 +
            "%"
          : "-";
        this.participacionDeseada = this.deseada
          ? Math.round(100 * 10 * (this.deseadaCalculada / this.deseada)) / 10 +
            "%"
          : "-";

        if (res.dependencies && res.dependencies.length > 0) {
          this.applyDependenciesToTable(res.dependencies);
        }

        this.applyWords(res);
      });

      // Shared mode with a filter param: apply it on top of the base load.
      if (this.isShared && this.$route.params.filter) {
        try {
          const decoded = JSON.parse(
            atob(atob(this.$route.params.filter)),
          );
          if (Array.isArray(decoded) && decoded.length > 0) {
            const rows = decoded.map((d) => ({
              dependency: d.name,
              subgrupo: d.value,
              n: 0,
            }));
            await this.loadGroupFilter(rows);
          }
        } catch (e) {
          console.log("Invalid share filter param", e);
        }
      }
    },
    applyResultsData(res) {
      this.totalCalculatedN = res.totalCalculated || 0;
      this.culturaActual = [
        res.cultura.Clan_hoy.participation,
        res.cultura.Adhocracia_hoy.participation,
        res.cultura.Mercado_hoy.participation,
        res.cultura.Jerarquica_hoy.participation,
      ];
      this.culturaDeseada = [
        res.cultura.Clan_futuro.participation,
        res.cultura.Adhocracia_futuro.participation,
        res.cultura.Mercado_futuro.participation,
        res.cultura.Jerarquica_futuro.participation,
      ];

      this.culturaTabla[0] = {
        cultura: "Colaboración",
        actual: res.cultura.Clan_hoy.participation,
        deseada: res.cultura.Clan_futuro.participation,
        brecha: res.cultura.Clan_futuro.count
          ? res.cultura.Clan_futuro.participation -
            res.cultura.Clan_hoy.participation
          : 0,
      };
      this.culturaTabla[1] = {
        cultura: "Creación",
        actual: res.cultura.Adhocracia_hoy.participation,
        deseada: res.cultura.Adhocracia_futuro.participation,
        brecha: res.cultura.Adhocracia_futuro.count
          ? res.cultura.Adhocracia_futuro.participation -
            res.cultura.Adhocracia_hoy.participation
          : 0,
      };
      this.culturaTabla[2] = {
        cultura: "Competencia",
        actual: res.cultura.Mercado_hoy.participation,
        deseada: res.cultura.Mercado_futuro.participation,
        brecha: res.cultura.Mercado_futuro.count
          ? res.cultura.Mercado_futuro.participation -
            res.cultura.Mercado_hoy.participation
          : 0,
      };
      this.culturaTabla[3] = {
        cultura: "Control",
        actual: res.cultura.Jerarquica_hoy.participation,
        deseada: res.cultura.Jerarquica_futuro.participation,
        brecha: res.cultura.Jerarquica_futuro.count
          ? res.cultura.Jerarquica_futuro.participation -
            res.cultura.Jerarquica_hoy.participation
          : 0,
      };
      this.$set(this.culturaTabla, 4, {
        cultura: "Sin dominancia",
        actual: res.cultura.Ninguna_hoy
          ? res.cultura.Ninguna_hoy.participation
          : 0,
        deseada: res.cultura.Ninguna_futuro
          ? res.cultura.Ninguna_futuro.participation
          : 0,
        brecha:
          res.cultura.Ninguna_futuro && res.cultura.Ninguna_futuro.count
            ? res.cultura.Ninguna_futuro.participation -
              (res.cultura.Ninguna_hoy
                ? res.cultura.Ninguna_hoy.participation
                : 0)
            : 0,
      });

      this.culturaActual_1 = [
        res.CD.Clan_hoy.participation,
        res.CD.Adhocracia_hoy.participation,
        res.CD.Mercado_hoy.participation,
        res.CD.Jerarquica_hoy.participation,
      ];
      this.culturaDeseada_1 = [
        res.CD.Clan_futuro.participation,
        res.CD.Adhocracia_futuro.participation,
        res.CD.Mercado_futuro.participation,
        res.CD.Jerarquica_futuro.participation,
      ];

      this.culturaActual_2 = [
        res.CE.Clan_hoy.participation,
        res.CE.Adhocracia_hoy.participation,
        res.CE.Mercado_hoy.participation,
        res.CE.Jerarquica_hoy.participation,
      ];
      this.culturaDeseada_2 = [
        res.CE.Clan_futuro.participation,
        res.CE.Adhocracia_futuro.participation,
        res.CE.Mercado_futuro.participation,
        res.CE.Jerarquica_futuro.participation,
      ];

      this.culturaActual_3 = [
        res.LO.Clan_hoy.participation,
        res.LO.Adhocracia_hoy.participation,
        res.LO.Mercado_hoy.participation,
        res.LO.Jerarquica_hoy.participation,
      ];
      this.culturaDeseada_3 = [
        res.LO.Clan_futuro.participation,
        res.LO.Adhocracia_futuro.participation,
        res.LO.Mercado_futuro.participation,
        res.LO.Jerarquica_futuro.participation,
      ];

      this.culturaActual_4 = [
        res.EE.Clan_hoy.participation,
        res.EE.Adhocracia_hoy.participation,
        res.EE.Mercado_hoy.participation,
        res.EE.Jerarquica_hoy.participation,
      ];
      this.culturaDeseada_4 = [
        res.EE.Clan_futuro.participation,
        res.EE.Adhocracia_futuro.participation,
        res.EE.Mercado_futuro.participation,
        res.EE.Jerarquica_futuro.participation,
      ];

      this.culturaActual_5 = [
        res.SP.Clan_hoy.participation,
        res.SP.Adhocracia_hoy.participation,
        res.SP.Mercado_hoy.participation,
        res.SP.Jerarquica_hoy.participation,
      ];
      this.culturaDeseada_5 = [
        res.SP.Clan_futuro.participation,
        res.SP.Adhocracia_futuro.participation,
        res.SP.Mercado_futuro.participation,
        res.SP.Jerarquica_futuro.participation,
      ];

      this.culturaActual_6 = [
        res.VL.Clan_hoy.participation,
        res.VL.Adhocracia_hoy.participation,
        res.VL.Mercado_hoy.participation,
        res.VL.Jerarquica_hoy.participation,
      ];
      this.culturaDeseada_6 = [
        res.VL.Clan_futuro.participation,
        res.VL.Adhocracia_futuro.participation,
        res.VL.Mercado_futuro.participation,
        res.VL.Jerarquica_futuro.participation,
      ];
    },
    applyWords(res) {
      const frases = [];
      for (let i = 0; i < Object.keys(res.words || {}).length; i++) {
        res.words[i].forEach((word) => {
          frases.push({
            tipo: i === 0 ? "Actual" : "Deseada",
            frase: word,
          });
        });
      }

      this.frases = frases;
      this.processedWordsActual = buildWordCloudData(
        (res.words && res.words[0]) || [],
      );
      this.processedWordsDeseada = buildWordCloudData(
        (res.words && res.words[1]) || [],
      );
    },
    applyDependenciesToTable(deps) {
      this.dataGroups = deps
        .filter((d) => d.calculations && d.calculations.cultura)
        .map((d) => ({
          dependency: d.dependency,
          subgrupo: d.subGroup != null ? String(d.subGroup) : '',
          n: d.total,
          clanActual: d.calculations.cultura.Clan_hoy
            ? d.calculations.cultura.Clan_hoy.participation
            : 0,
          clanDeseada: d.calculations.cultura.Clan_futuro
            ? d.calculations.cultura.Clan_futuro.participation
            : 0,
          adhActual: d.calculations.cultura.Adhocracia_hoy
            ? d.calculations.cultura.Adhocracia_hoy.participation
            : 0,
          adhDeseada: d.calculations.cultura.Adhocracia_futuro
            ? d.calculations.cultura.Adhocracia_futuro.participation
            : 0,
          jerActual: d.calculations.cultura.Jerarquica_hoy
            ? d.calculations.cultura.Jerarquica_hoy.participation
            : 0,
          jerDeseada: d.calculations.cultura.Jerarquica_futuro
            ? d.calculations.cultura.Jerarquica_futuro.participation
            : 0,
          merActual: d.calculations.cultura.Mercado_hoy
            ? d.calculations.cultura.Mercado_hoy.participation
            : 0,
          merDeseada: d.calculations.cultura.Mercado_futuro
            ? d.calculations.cultura.Mercado_futuro.participation
            : 0,
        }));
    },
    aggregateCalculations(deps) {
      const dims = ["cultura", "CD", "CE", "LO", "EE", "SP", "VL"];
      const hoyKeys = [
        "Clan_hoy",
        "Adhocracia_hoy",
        "Mercado_hoy",
        "Jerarquica_hoy",
      ];
      const futuroKeys = [
        "Clan_futuro",
        "Adhocracia_futuro",
        "Mercado_futuro",
        "Jerarquica_futuro",
      ];
      const allKeys = [...hoyKeys, ...futuroKeys, "Ninguna"];
      const result = {};

      dims.forEach((dim) => {
        result[dim] = {};
        allKeys.forEach((key) => {
          result[dim][key] = { count: 0, participation: 0 };
        });

        deps.forEach((dep) => {
          allKeys.forEach((key) => {
            const dimData = dep.calculations[dim];
            result[dim][key].count +=
              dimData && dimData[key] && dimData[key].count
                ? dimData[key].count
                : 0;
          });
        });

        const totalHoy =
          hoyKeys.reduce((s, k) => s + result[dim][k].count, 0) +
          result[dim]["Ninguna"].count;
        const totalFuturo = futuroKeys.reduce(
          (s, k) => s + result[dim][k].count,
          0,
        );

        hoyKeys.forEach((key) => {
          result[dim][key].participation =
            totalHoy > 0
              ? Math.round((1000 * result[dim][key].count) / totalHoy) / 10
              : 0;
        });
        futuroKeys.forEach((key) => {
          result[dim][key].participation =
            totalFuturo > 0
              ? Math.round((1000 * result[dim][key].count) / totalFuturo) / 10
              : 0;
        });
        result[dim]["Ninguna"].participation =
          totalHoy > 0
            ? Math.round((1000 * result[dim]["Ninguna"].count) / totalHoy) / 10
            : 0;
      });

      return result;
    },
    async loadGroupFilter(rows) {
      if (!rows || rows.length === 0) {
        if (this.pendingFilterRows !== null) return; // cascade from table update, ignore
        this.applyResultsData(this.rawRes);
        this.applyDependenciesToTable(this.rawRes.dependencies);
        this.applyWords(this.rawRes);
        this.activeFilter = null;
        this.lastFilterRows = [];
        return;
      }

      this.pendingFilterRows = rows;
      const dependencies = rows.map((r) => ({
        name: r.dependency,
        value: r.subgrupo,
      }));

      let res = null;
      try {
        res = this.isShared
          ? await getSharedResults(this.$route.params.id, dependencies)
          : await getResultByDependency(this.currentProcess._id, dependencies);
        this.applyResultsData(res);
        if (res.dependencies && res.dependencies.length > 0) {
          this.applyDependenciesToTable(res.dependencies);
        }
        this.applyWords(res);
      } catch (e) {
        console.error("Error fetching filtered results", e);
      } finally {
        this.pendingFilterRows = null;
      }

      this.lastFilterRows = rows;

      // Fall back to the response's totalCalculated when rows don't carry `n`
      // (e.g. filter rehydrated from URL in shared mode).
      const lastRow = rows.at(-1);
      const totalN =
        lastRow && lastRow.n
          ? lastRow.n
          : (res && (res.totalCalculated || res.total)) || 0;
      if (rows.length === 1) {
        this.activeFilter = {
          dependency: rows[0].dependency,
          subgrupo: rows[0].subgrupo,
          n: totalN,
        };
      } else {
        this.activeFilter = {
          dependency: `${rows.length} grupos seleccionados`,
          subgrupo: null,
          n: totalN,
          items: rows.map((r) => ({
            label:
              r.subgrupo && r.subgrupo !== r.dependency
                ? `${r.dependency} · ${r.subgrupo}`
                : r.dependency,
          })),
        };
      }
    },
    clearFilter() {
      this.pendingFilterRows = [];
      this.applyResultsData(this.rawRes);
      this.applyDependenciesToTable(this.rawRes.dependencies);
      this.applyWords(this.rawRes);
      this.activeFilter = null;
      this.lastFilterRows = [];
      this.$refs.tableGroups.clearSelection();
      this.$nextTick(() => {
        this.pendingFilterRows = null;
      });
    },
    onWordSelected(word) {
      console.log("word selected", word);
    },
    copyLink() {
      const filterRows = (this.lastFilterRows || []).map((r) => ({
        name: r.dependency,
        value: r.subgrupo,
      }));
      const encodedFilter = btoa(btoa(JSON.stringify(filterRows)));
      const url =
        window.location.host +
        "/cultura/share/" +
        this.currentProcess._id +
        "/" +
        encodedFilter;

      const textArea = document.createElement("textarea");
      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = 0;
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";
      textArea.value = url;

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand("copy");
        this.$store.dispatch("notify", {
          message: successful ? "¡Copiado al portapapeles!" : "Error al copiar",
          type: successful ? "is-link" : "is-danger",
        });
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Error al copiar",
          type: "is-danger",
        });
      }
      document.body.removeChild(textArea);
    },
    downloadWords() {
      this.$buefy.toast.open({
        message: "Descargando Excel...",
        type: "is-info",
      });

      const data = this.frases.map((w) => ({
        Frase: w.frase,
        Tipo: w.tipo,
      }));

      const ws = XLSX.utils.json_to_sheet(data);

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Frases");

      XLSX.writeFile(wb, this.currentProcess.name + "_Frases.xlsx");
    },
    downloadResultsData() {
      this.$buefy.toast.open({
        message: "Descargando Excel...",
        type: "is-info",
      });

      try {
        const res = this.rawRes;

        const ARCHETYPES = [
          { key: "Clan", label: "Colaboración" },
          { key: "Adhocracia", label: "Creación" },
          { key: "Mercado", label: "Competencia" },
          { key: "Jerarquica", label: "Control" },
        ];
        const DIMENSIONS = [
          { key: "cultura", label: "General" },
          { key: "CD", label: "Características dominantes" },
          { key: "CE", label: "Criterios de éxito" },
          { key: "LO", label: "Liderazgo organizacional" },
          { key: "EE", label: "Énfasis estratégico" },
          { key: "SP", label: "Solución de problemas" },
          { key: "VL", label: "Valores" },
        ];
        const stat = (obj, key) =>
          (obj && obj[key]) || { participation: 0, count: 0 };

        // Hoja "General"
        const generalRows = [];
        DIMENSIONS.forEach((dimension) => {
          const dim = (res && res[dimension.key]) || {};
          ARCHETYPES.forEach((archetype) => {
            const actual = stat(dim, archetype.key + "_hoy");
            const deseada = stat(dim, archetype.key + "_futuro");
            generalRows.push({
              Dimensión: dimension.label,
              Cultura: archetype.label,
              "Actual (%)": actual.participation,
              "Deseada (%)": deseada.participation,
              Brecha: deseada.count ? deseada.participation - actual.participation : 0,
            });
          });
          if (dimension.key === "cultura") {
            const actual = stat(dim, "Ninguna_hoy");
            const deseada = stat(dim, "Ninguna_futuro");
            generalRows.push({
              Dimensión: dimension.label,
              Cultura: "Sin dominancia",
              "Actual (%)": actual.participation,
              "Deseada (%)": deseada.participation,
              Brecha: deseada.count ? deseada.participation - actual.participation : 0,
            });
          }
        });

        // Hoja "Por grupo"
        const groupRows = [];
        const dependencies = (res && res.dependencies) || [];
        dependencies
          .filter((d) => d.calculations && d.calculations.cultura)
          .forEach((d) => {
            DIMENSIONS.forEach((dimension) => {
              const dim = d.calculations[dimension.key] || {};
              const row = {
                Dependencia: d.dependency,
                Subgrupo: d.subGroup != null ? String(d.subGroup) : "",
                n: d.total,
                Dimensión: dimension.label,
              };
              ARCHETYPES.forEach((archetype) => {
                row[archetype.label + " Actual"] = stat(
                  dim,
                  archetype.key + "_hoy",
                ).participation;
                row[archetype.label + " Deseada"] = stat(
                  dim,
                  archetype.key + "_futuro",
                ).participation;
              });
              groupRows.push(row);
            });
          });

        // Hoja "Palabras clave"
        const fraseRows = [];
        const words = (res && res.words) || {};
        Object.keys(words).forEach((key, idx) => {
          (words[key] || []).forEach((word) => {
            fraseRows.push({
              Frase: word,
              Tipo: idx === 0 ? "Actual" : "Deseada",
            });
          });
        });

        const wsGeneral = XLSX.utils.json_to_sheet(generalRows);
        wsGeneral["!cols"] = this.widthCols(generalRows);
        const wsGrupo = XLSX.utils.json_to_sheet(groupRows);
        wsGrupo["!cols"] = this.widthCols(groupRows);
        const wsFrases = XLSX.utils.json_to_sheet(fraseRows);
        wsFrases["!cols"] = this.widthCols(fraseRows);

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, wsGeneral, "General");
        XLSX.utils.book_append_sheet(wb, wsGrupo, "Por grupo");
        XLSX.utils.book_append_sheet(wb, wsFrases, "Palabras clave");
        XLSX.writeFile(
          wb,
          this.currentProcess.name + "_Resultados-Completos.xlsx",
        );
      } catch (err) {
        console.log(err);
        this.$store.dispatch("notify", {
          message: "Hubo un problema, no se pudo generar el excel",
          type: "is-danger",
        });
      }
    },
    widthCols(data) {
      if (!data.length) return [];

      const headers = Object.keys(data[0]);
      return headers.map((header) => {
        const headerLength = String(header || "").length + 2;
        const maxCellLength = data.reduce((max, row) => {
          const cellLength = String(row[header] || "").length + 2;
          return Math.max(max, cellLength);
        }, 0);
        return { width: Math.max(headerLength, maxCellLength) };
      });
    },
  },
};
</script>
<style>
.filter-banner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  background: #f3e8ff;
  border-left: 4px solid #660099;
  color: #4a148c;
  padding: 10px 20px;
  border-radius: 6px;
  margin-bottom: 12px;
  font-size: 14px;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.02);
}

.filter-banner-top {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.filter-banner-items {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.filter-banner-chip {
  background: #ede0f7;
  border: 1px solid #c084fc;
  color: #4a148c;
  border-radius: 12px;
  padding: 2px 10px;
  font-size: 11px;
  white-space: nowrap;
}

.filter-banner-clear {
  background: none;
  border: 1px solid #660099;
  color: #660099;
  border-radius: 4px;
  padding: 4px 12px;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.15s, color 0.15s;
}

.filter-banner-clear:hover {
  background: #660099;
  color: #fff;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.2s ease;
}
.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.background-fade {
  background: linear-gradient(
    to right,
    white 0%,
    #f5f5f5 2%,
    #f5f5f5 98%,
    white 100%
  );
}
.words-table-wrapper {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
}

.words-table thead th {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
}

.words-table .col-rank,
.words-table .col-word {
  width: 1%;
  white-space: nowrap;
}

.words-table .col-freq {
  width: auto;
}

.freq-bar {
  position: relative;
  height: 22px;
  width: 100%;
  background: #f3f4f6;
  border-radius: 2px;
  overflow: hidden;
}

.freq-bar-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: #D972A366;
  border-radius: 2px;
}

.freq-bar-label {
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  font-weight: 600;
  color: #444;
}

.chart-toggle {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.toggle-wrapper {
  display: flex;
  align-items: center;
  background: #f3f4f6; /* gris suave */
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 0.9rem;
  gap: 10px;
}

.toggle-item {
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  color: #6b7280; /* gris */
  font-weight: 500;
  transition: all 0.2s ease;
}

.toggle-item:hover {
  background: #e5e7eb;
}

.toggle-item.active {
  background: #511387;
  color: white;
  font-weight: 600;
}

.divider {
  color: #9ca3af;
  user-select: none;
}
/* Legend styles */
.chart-legend {
  margin-top: 0.5rem;
}

/* fila horizontal con wrap si es necesario */
.legend-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

/* elemento (swatch + texto) */
.legend-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.95rem;
  color: #333;
}

/* separador visual (línea fina) */
.legend-separator {
  width: 1px;
  height: 18px;
  background: rgba(0, 0, 0, 0.08);
  margin: 0 0.5rem;
}

/* caja de color (sin sombra, esquinas redondeadas 2px) */
.legend-swatch {
  display: inline-block;
  width: 18px;
  height: 12px;
  border-radius: 2px; /* <- redondeo 2px */
  flex-shrink: 0;
}

/* colores (ajusta si quieres) */
.swatch-actual {
  background: #d04e8ccc; /* rosa */
}
.swatch-deseada {
  background: #4a90e2cc; /* azul */
}
.swatch-brecha {
  background: #f59e0bcc; /* ejemplo amarillo */
}

/* Texto de la leyenda */
.legend-text {
  line-height: 1;
  font-weight: 100;
  color: #4a4a4a;
}

.header-actual {
  color: #d04e8c !important; /* azul */
  font-weight: 600;
}

.header-deseada {
  color: #4a90e2 !important; /* morado */
  font-weight: 600;
}

/* Responsividad: en pantallas muy pequeñas reduce gaps y tamaño */
@media (max-width: 480px) {
  .legend-row {
    gap: 0.5rem;
  }
  .legend-swatch {
    width: 14px;
    height: 10px;
  }
  .legend-text {
    font-size: 0.85rem;
  }
  .legend-separator {
    height: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/sections/results/Results.vue